export function scrollProgress() {
    const progressFill = document.querySelector(".progress-bar__fill");
    if (!progressFill) return;

    document.addEventListener("scroll", () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrolled = (scrollTop / docHeight) * 100;
        progressFill.style.width = scrolled + "%";
    });
}
